import { useTranslation } from '../../locale/context';

import wild_1 from '../assets/bonus/wilds.png';
import Crystal from '../assets/bonus/crystal.png';
import Heart from '../assets/bonus/heart.png';
import Star from '../assets/bonus/star.png';
import Bonuses from '../assets/bonus/bonuses.png';

// import { GameConfigs } from "../../lib/globals/GameConfigs";

export const WILDS = [wild_1];
export const PROGRESSIVE = [Bonuses];

export const BONUS_DESC_1 = ({ minfs }) => {
	const { t } = useTranslation();
	return (
		<div
			dangerouslySetInnerHTML={{
				__html: t('gameRules.scatter_trigger_visual', { minfs })
			}}
		></div>
	);
};

export const BONUS_DESC_2 = () => {
	const { t } = useTranslation();
	return (
		<div
			dangerouslySetInnerHTML={{
				__html: t('gameRules.wild_visual')
			}}
		></div>
	);
};

export const PROGRESSIVE_DESC_1 = () => {
	const { t } = useTranslation();

	return (
		<div
			dangerouslySetInnerHTML={{
				__html: t('gameRules.crystal_bonus', {
					crystal: Crystal
				})
			}}
		/>
	);
};

export const PROGRESSIVE_DESC_2 = () => {
	const { t } = useTranslation();

	return (
		<div
			dangerouslySetInnerHTML={{
				__html: t('gameRules.progressive_desc_2', {
					heart: Heart,
					star: Star
				})
			}}
		/>
	);
};

export const QUEST_DESC_1 = () => {
	const { t } = useTranslation();

	return (
		<>
			<div>{t('gameRules.quest_desc_1')}</div>
		</>
	);
};

export const QUEST_DESC_2 = () => {
	const { t } = useTranslation();
	// CHECK
	return (
		<div
			dangerouslySetInnerHTML={{
				__html: t('gameRules.quest_desc_2')
			}}
		/>
	);
};

export const SPECS_DESC_1 = () => {
	const { t } = useTranslation();

	return (
		<div
			dangerouslySetInnerHTML={{
				__html: t('gameRules.specs_desc_1')
			}}
		/>
	);
};

export const SPECS_DESC_2 = (rtp) => {
	const { t } = useTranslation();

	return (
		<div
			dangerouslySetInnerHTML={{
				__html: t('gameRules.specs_desc_2', { rtp })
			}}
		/>
	);
};
